import { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { SwitchTenantCard } from 'Common/Supplyvue-ui'
import { Loader } from 'Common/Loader/Loader'
import { useTenantListData } from './TenantList.data'
import { Page } from 'Common/Page/Page'
import SwitchIcon from 'Assets/icons/switch.svg'
import { TenantListPageProps } from './TenantList.types'

export const TenantListPage = ({
  autoRedirect = true,
}: TenantListPageProps) => {
  const { isLoading, data } = useTenantListData()
  const tenant = localStorage.getItem('tenantId') ?? ''
  const [redirectCount, setRedirectCount] = useState<number>(0)

  // Check if we're in an auth redirect flow
  const isAuthRedirect =
    sessionStorage.getItem('authRedirectInProgress') === 'true'

  useEffect(() => {
    // Only clear storage if we're not in an auth redirect flow
    if (autoRedirect && !isAuthRedirect) {
      localStorage.removeItem('tenantId')
      localStorage.removeItem('tenantsCount')
      localStorage.removeItem('tenantName')
    }

    // Track number of times this component has mounted in this session
    const count = parseInt(
      sessionStorage.getItem('tenantPageVisitCount') ?? '0'
    )
    sessionStorage.setItem('tenantPageVisitCount', (count + 1).toString())
    setRedirectCount(count + 1)

    // If we've been to this page too many times, clear the auth redirect flag
    // to break potential infinite loops
    if (count >= 2) {
      sessionStorage.removeItem('authRedirectInProgress')
    }
  }, [autoRedirect, isAuthRedirect])

  useEffect(() => {
    if (autoRedirect && !isLoading && data?.length === 1 && !isAuthRedirect) {
      const tenantId = data[0].id
      const tenantName = data[0].name
      const tenantsCount = data?.length.toString()
      localStorage.setItem('tenantId', tenantId)
      localStorage.setItem('tenantName', tenantName)
      localStorage.setItem('tenantsCount', tenantsCount)

      // Clear any redirect counters before navigating away
      sessionStorage.removeItem('tenantPageVisitCount')
      window.location.href = window.location.origin
    }
  }, [autoRedirect, isLoading, data, isAuthRedirect])

  const handleSwitchTenantClick = (tenantId: string | number) => {
    const selectedTenant = data?.find((tenant) => tenant.id === tenantId)
    const tenantsCount = data?.length.toString()
    localStorage.setItem('tenantId', selectedTenant?.id as string)
    localStorage.setItem('tenantName', selectedTenant?.name as string)
    localStorage.setItem('tenantsCount', tenantsCount as string)

    // Clear any redirect counters before navigating away
    sessionStorage.removeItem('tenantPageVisitCount')
    sessionStorage.removeItem('authRedirectInProgress')

    /** Redirecting user than re-routing as header component updation needs global state
     * like redux which is unnecessary at this moment. If in the future, redux has been
     * integrated, please maintain tenantName in redux store and use that in the Header.
     * Replace location.href with history.push() */
    window.location.href = window.location.origin
  }

  if (isLoading || !data || (autoRedirect && data.length === 1)) {
    return <Loader />
  }
  return (
    <Page center>
      <Box width="80%">
        <SwitchTenantCard
          title="Select a tenant"
          initialTenantId={tenant}
          tenantList={data}
          switchTenantIcon={<SwitchIcon width="24px" height="24px" />}
          primaryButtonLabel="OK"
          secondaryButtonLabel="Cancel"
          showSecondaryButton={!autoRedirect}
          handlePrimaryButtonClick={handleSwitchTenantClick}
          handleSecondaryButtonClick={() =>
            (window.location.href = window.location.origin)
          }
        />
      </Box>
    </Page>
  )
}
